var Utils;
(function (Utils) {
    function setInputValue(element, value) {
        if (element) {
            element.value = value;
        }
    }
    Utils.setInputValue = setInputValue;
    function elementExists(_elementId) {
        return !!document.getElementById(_elementId);
    }
    Utils.elementExists = elementExists;
    function allowNumbers(evt) {
        let theEvent = evt || window.event;
        if (theEvent.ctrlKey || theEvent.metaKey)
            return;
        let key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
        if (key.length == 0)
            return;
        var regex = /^[0-9.,\-\b]+$/;
        if (!regex.test(key)) {
            theEvent.returnValue = false;
            if (theEvent.preventDefault)
                theEvent.preventDefault();
        }
    }
    Utils.allowNumbers = allowNumbers;
    function allowNumbersWoDot(evt) {
        let theEvent = evt || window.event;
        if (theEvent.ctrlKey || theEvent.metaKey)
            return;
        let key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);
        if (key.length == 0)
            return;
        var regex = /^[0-9,\-\b]+$/;
        if (!regex.test(key)) {
            theEvent.returnValue = false;
            if (theEvent.preventDefault)
                theEvent.preventDefault();
        }
    }
    Utils.allowNumbersWoDot = allowNumbersWoDot;
    function sanitizeNumericInput(evt) {
        var _a, _b;
        const input = evt.target;
        if (!input)
            return;
        const originalValue = input.value;
        const selectionStart = (_a = input.selectionStart) !== null && _a !== void 0 ? _a : originalValue.length;
        const selectionEnd = (_b = input.selectionEnd) !== null && _b !== void 0 ? _b : selectionStart;
        const trimmedValue = originalValue.trim();
        const isAccountingNegative = trimmedValue.startsWith("(") &&
            trimmedValue.endsWith(")");
        const sanitize = (value) => value.replace(/[^0-9.,\-]/g, "");
        let sanitizedValue = sanitize(originalValue);
        const addAccountingSign = isAccountingNegative && !sanitizedValue.startsWith("-");
        if (addAccountingSign)
            sanitizedValue = `-${sanitizedValue}`;
        if (sanitizedValue == originalValue)
            return;
        const signOffset = addAccountingSign ? 1 : 0;
        const newSelectionStart = Math.min(sanitize(originalValue.substring(0, selectionStart)).length + signOffset, sanitizedValue.length);
        const newSelectionEnd = Math.min(sanitize(originalValue.substring(0, selectionEnd)).length + signOffset, sanitizedValue.length);
        input.value = sanitizedValue;
        input.setSelectionRange(newSelectionStart, newSelectionEnd);
    }
    Utils.sanitizeNumericInput = sanitizeNumericInput;
    function isEditableElement(target) {
        const element = target;
        return element instanceof HTMLInputElement ||
            element instanceof HTMLTextAreaElement ||
            (element === null || element === void 0 ? void 0 : element.isContentEditable);
    }
    Utils.isEditableElement = isEditableElement;
    function padZeros(number, digits) {
        return Array(Math.max(digits - String(number).length + 1, 0)).join("0") + number;
    }
    Utils.padZeros = padZeros;
    function scrollToBottom(containerId, elementId) {
        if (!containerId)
            return;
        var element = document.getElementById(containerId);
        if (element) {
            element.scrollTop = element.scrollHeight;
        }
    }
    Utils.scrollToBottom = scrollToBottom;
    function scrollParentToChild(parentId, childId) {
        requestAnimationFrame(() => {
            const parent = document.getElementById(parentId);
            if (!parent) {
                console.warn(`Parent element with id '${parentId}' not found`);
                return;
            }
            const child = document.getElementById(childId);
            if (!child) {
                console.warn(`Child element with id '${childId}' not found`);
                return;
            }
            const parentRect = parent.getBoundingClientRect();
            const childRect = child.getBoundingClientRect();
            const isAbove = childRect.top < parentRect.top;
            const isBelow = childRect.bottom > parentRect.bottom;
            const isVisible = !isAbove && !isBelow;
            if (!isVisible) {
                const parentScrollTop = parent.scrollTop;
                const childOffsetTop = child.offsetTop;
                const parentOffsetTop = parent.offsetTop;
                if (isAbove) {
                    parent.scrollTop = childOffsetTop - parentOffsetTop;
                }
                else if (isBelow) {
                    const childHeight = child.offsetHeight;
                    const parentHeight = parent.clientHeight;
                    parent.scrollTop = childOffsetTop - parentOffsetTop - parentHeight + childHeight;
                }
                console.log("scrolled to child");
            }
            else {
                console.log("child already visible");
            }
        });
    }
    Utils.scrollParentToChild = scrollParentToChild;
    function scrollContainerToPosition(containerId, scrollTop) {
        const container = document.getElementById(containerId);
        if (container) {
            container.scrollTop = scrollTop;
        }
    }
    Utils.scrollContainerToPosition = scrollContainerToPosition;
    function simulateKeyPress(keyCode) {
        var evt = new KeyboardEvent('keypress', { keyCode: keyCode });
        document.dispatchEvent(evt);
    }
    Utils.simulateKeyPress = simulateKeyPress;
    function blurElement(elementId) {
        var element = document.getElementById(elementId);
        if (element) {
            element.blur();
        }
    }
    Utils.blurElement = blurElement;
    function showPicker(elementId) {
        var element = document.getElementById(elementId);
        if (!element)
            return;
        if (typeof element.showPicker === "function") {
            try {
                element.showPicker();
                return;
            }
            catch (_a) {
            }
        }
        element.focus();
        element.click();
    }
    Utils.showPicker = showPicker;
})(Utils || (Utils = {}));
